import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/HolidayBorder';

export const HOLIDAY_BORDER_LEFT_GET_SUCCESS = `${rootActionPath}Left/GET_${SUCCESS_SUFFIX}`;
export const HOLIDAY_BORDER_LEFT_GET_FAILURE = `${rootActionPath}Left/GET_${FAILURE_SUFFIX}`;
export const HOLIDAY_BORDER_RIGHT_GET_SUCCESS = `${rootActionPath}Right/GET_${SUCCESS_SUFFIX}`;
export const HOLIDAY_BORDER_RIGHT_GET_FAILURE = `${rootActionPath}Right/GET_${FAILURE_SUFFIX}`;
